<template>
  <NotificationBase>
    <template v-slot:icon>
      <img
        class="h-full object-center object-contain w-full"
        src="@/assets/icons/note-bell.svg">
    </template>
    <template v-slot>
      <span class="text-12px leading-14px">
        Зарегистрирован исполнитель в новом регионе
        <b class="cursor-pointer">{{ $delve(region, 'name') }}</b>
      </span>
    </template>
  </NotificationBase>
</template>

<script>
import NotificationBase from '@/components/Notifications/Core/NotificationBase.vue';

export default {
  props: {
    payload: {
      type: Object,
      required: true,
    },
  },
  components: {
    NotificationBase,
  },
  computed: {
    region() {
      return this.$delve(this.payload, 'contractorRegisteredInInactiveRegion.region');
    },
  },
};
</script>
